// Module
var code = `<div class="external-content-container">
  <ul class="external-content plugin-content-features">
    {{#content.features}}

    <li class="feature-item">
      <p>{{.*}}</p>
    </li>

    {{/content.features}}
  </ul>
</div>
`;
// Exports
module.exports = code;